import { useCaseCreationStore } from "../../../../store/useCaseCreationStore";
import BodyLocationForm from "../../components/forms/BodyLocationForm";

export default function BodyLocation({ onNext, onBack }: any) {

   const { deceasedLocation, setDeceasedLocation } = useCaseCreationStore();

  return (
    <BodyLocationForm
      deceasedLocation={deceasedLocation}
      setDeceasedLocation={setDeceasedLocation}
      onNext={onNext}
      onBack={onBack}
    />
  );
}